import { render, staticRenderFns } from "./ParticipantConfig.vue?vue&type=template&id=6bc74a66&scoped=true&"
import script from "./ParticipantConfig.vue?vue&type=script&lang=js&"
export * from "./ParticipantConfig.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantConfig.vue?vue&type=style&index=0&id=6bc74a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc74a66",
  null
  
)

export default component.exports